import {FILTER_TYPE, GLOBAL_FILTER_OPERATOR, GLOBAL_FILTER_FIELD} from '../../../constants';
import Util from '../../../forecast-app/shared/util/util';

export const allPersonId = viewer => viewer.company.allPersons.edges.map(p => p.node.id);
export const allTeamsId = viewer => viewer.company.teams.edges.map(t => t.node.id);

export const getPersonsFiltered = () => {
	if (localStorage.getItem('team-timesheet-filters')) {
		const filterParsed = JSON.parse(localStorage.getItem('team-timesheet-filters'));
		return filterParsed || [];
	} else {
		return {person: {}};
	}
};

export const getPersonIdsFiltered = viewer => {
	let filterKey = 'timesheets-team-filter-v4';
	if (localStorage.getItem(filterKey)) {
		const filterParsed = JSON.parse(localStorage.getItem(filterKey));
		let ids = {};
		// TODO: This function is currently taking an approach to filtering which does not align with the rest of the platform
		// This should be refactored to filter by exposing the property which is being filtered and then checking if the person possesses the property
		// The hack by adding 'no match' if the person does not match is a band-aid fix causing the filter to work.
		if (filterParsed.person) {
			if (filterParsed.person.teamMember) {
				ids.teamMember = filterParsed.person.teamMember;
			}
			if (filterParsed.person.team) {
				ids.team = [];
				filterParsed.person.team.forEach(teamId => {
					viewer.company.teams.edges.forEach(t => {
						if (t.node.id === teamId) {
							ids.team = ids.team.concat(t.node.teamPersons.edges.map(p => p.node.person.id));
						} else {
							ids.team.push('no match');
						}
					});
				});
			}
			if (filterParsed.person.role) {
				ids.role = [];
				filterParsed.person.role.forEach(roleId => {
					viewer.company.allPersons.edges.forEach(t => {
						if (t.node.role && t.node.role.id === roleId) {
							ids.role.push(t.node.id);
						} else {
							ids.role.push('no match');
						}
					});
				});
			}

			if (filterParsed.person.department) {
				ids.department = [];
				filterParsed.person.department.forEach(departmentId => {
					viewer.company.allPersons.edges.forEach(t => {
						if (t.node.department && t.node.department.id === departmentId) {
							ids.department.push(t.node.id);
						} else {
							ids.department.push('no match');
						}
					});
				});
			}

			if (filterParsed.person.label) {
				ids.label = [];
				filterParsed.person.label.forEach(label => {
					viewer.company.allPersons.edges.forEach(t => {
						t.node.personLabels.edges.forEach(persLabel => {
							if (persLabel.node.label.id === label) {
								ids.label.push(t.node.id);
							} else {
								ids.label.push('no match');
							}
						});
					});
				});
			}
		}

		return ids;
	} else {
		return allPersonId(viewer);
	}
};

export const personFiltersType = [FILTER_TYPE.TEAM_MEMBER, FILTER_TYPE.TEAM, FILTER_TYPE.ROLE, FILTER_TYPE.DEPARTMENT];

export const filterValues = personFilter => personFilter;

const matchKey = key => {
	switch (key) {
		case FILTER_TYPE.TEAM_MEMBER:
			return GLOBAL_FILTER_FIELD.TEAM_MEMBER;
		case FILTER_TYPE.TEAM:
			return GLOBAL_FILTER_FIELD.TEAM;
		case FILTER_TYPE.ROLE:
			return GLOBAL_FILTER_FIELD.ROLE;
		case FILTER_TYPE.LABEL:
			return GLOBAL_FILTER_FIELD.LABELS;
		case FILTER_TYPE.DEPARTMENT:
			return GLOBAL_FILTER_FIELD.DEPARTMENT;
		default:
			break;
	}
};

// Parse from filterObject returned by the filter component to a searchQuery in the format used for globalSearch filtering
const parseSearchQuery = queryFilters => {
	const searchQuery = {};
	const filterValues = [];
	if (!queryFilters.person) {
		return searchQuery;
	}
	for (const [key, value] of Object.entries(queryFilters.person)) {
		if (personFiltersType.includes(key) && value.length > 0) {
			const formattedFilter = {
				field: matchKey(key),
				operator: GLOBAL_FILTER_OPERATOR.IN,
				value: value,
			};
			filterValues.push(formattedFilter);
		}
	}
	searchQuery.filters = filterValues;
	return searchQuery;
};

const sendRequest = (queryFilters, currentViewingDate, refetch) => {
	const startDate = currentViewingDate.clone().startOf('week').format('YYYY-MM-DD');

	const endDate = currentViewingDate.clone().endOf('week').format('YYYY-MM-DD');

	refetch({
		startDateString: startDate,
		endDateString: endDate,
		searchQuery: queryFilters,
	});
};

export const onFilterChange = (refetch, viewer, setPersonIdsFiltered, currentViewingDate, filters) => {
	let filterKey = 'team-timesheet-filters-v4';
	Util.localStorageSetItem(filterKey, JSON.stringify(filters));
	const parsedFilters = parseSearchQuery(filters);
	Util.localStorageSetItem(`team-timesheet-parsed-filters`, JSON.stringify(parsedFilters));

	setPersonIdsFiltered(getPersonIdsFiltered(viewer));
	sendRequest(parsedFilters, currentViewingDate, refetch);
};
